type ViteHotContext = Pick<NonNullable<ImportMeta['hot']>, 'on'>

type ViteDevRecoveryOptions = {
  hot: ViteHotContext | undefined
  eventTarget: EventTarget
  reload: () => void
}

export function registerViteDevRecovery({
  hot,
  eventTarget,
  reload,
}: ViteDevRecoveryOptions): void {
  let hasDisconnected = false
  let isReloading = false

  const reloadOnce = () => {
    if (isReloading) return

    isReloading = true
    reload()
  }

  eventTarget.addEventListener('vite:preloadError', event => {
    event.preventDefault()
    reloadOnce()
  })

  hot?.on('vite:ws:disconnect', () => {
    hasDisconnected = true
  })

  hot?.on('vite:ws:connect', () => {
    if (hasDisconnected) reloadOnce()
  })
}
